import React, { useState, useEffect } from 'react';

import {
    Container,
    Dialog,
    Button,
    DialogContent,
    DialogActions,
    Divider,
    Grid,
} from '@material-ui/core';
import SeatPicker from 'react-seat-picker'
import { toast } from 'react-toastify';
import { statusEnum } from '../../../config/status';

import Label from '../../../components/Label';
import Description from '../../../components/Description';
import CreatePerson from './CreatePerson';

import EventApi from '../../../services/event';
import topMapLayout from '../../../assets/images/stm_layout_top.svg';
import bottomMapLayout from '../../../assets/images/stm_layout_bottom.svg';

import {
    ContainerBox,
    Content,
    Row,
} from './styles';
import { config } from '../../../config';

const Map = (props) => {
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState({});
    const [selected, setSelected] = useState({});
    const [currentButton, setCurrentButton] = useState(<></>);
    const rows = props.rows;

    const handleOpen = () => { setOpen(true) };
    const handleClose = () => { setOpen(false) };

    useEffect(() => {
        EventApi.getStatus()
        .then(resp => {
            if (!!resp.data) {
                resp.data.data.forEach(item => {
                    const { id } = item;
                    const data = status
                    data[id] = item
                    setStatus(data)
                })
            }
        })
        .catch(function(error) {
            toast.error(error)
        });
    }, []);

    async function getPosition(id, row, number, func, kind) {
        props.onChangePerson({ target: { name: 'id', value: 0 } })
        setSelected({ row, number, id })
        EventApi.getPositionById(id)
        .then(resp => {
            if (!!resp.data) {
                if (resp.data.data.people.length) {
                    props.setPerson(resp.data.data.people[0])
                    if (kind === 'add') {
                        setCurrentButton(<Button
                            onClick={() => {
                                changeStatusPerson(id, 'SHOWED_UP', row, number, resp.data.data.people[0]);
                                func(row, number, id)
                            }}
                            >
                                convidado compareceu
                            </Button>)
                    } else {
                        setCurrentButton(
                            <Button
                                onClick={() => {
                                    changeStatusPerson(id, 'MISSED', row, number, resp.data.data.people[0]);
                                    func(row, number)
                                }}
                            >
                                convidado não compareceu
                            </Button>
                        )
                    }
                }
            }
            handleOpen()
        })
        .catch(function(error) {
            toast.error(error)
        });
    }

    async function changeStatusPerson(id, status_name, row, number, person) {
        let status_id = 0
        for (var prop in status) {
            if (status[prop].name === status_name) status_id = status[prop].id
        }
        await EventApi.updateStatusPerson(person.id, status_id)
        .then(resp => {
            toast.success('usuário alterado com sucesso!')
            props.onChangeRow(number, id, 'isSelected', status_name==='SHOWED_UP');
            props.onChangePerson({ target: { name: 'id', value: resp.data.data.people[0].id } })
            handleClose();
        })
        .catch(function(error) {
            toast.error(error)
            handleClose();
        });
    }

    const addSeatCallback = async ({ row, number, id }, addCb) => {
        getPosition(id, row, number, addCb, 'add');
    }

    const removeSeatCallback = async ({ row, number, id }, removeCb) => {
        getPosition(id, row, number, removeCb, 'remove');
    }

    const modal = (
        <Dialog fullWidth onClose={handleClose} open={open}>
            <ContainerBox className="content">
            <DialogContent>
                <Label
                    size='medium'
                    color='dark'
                    align='left'
                    weight='700'
                    padding='5px 0'
                >
                    posição
                </Label>
                <Grid container justify="space-around" spacing={2}>
                    <Grid item md={4}>
                        <Description name="id:" value={selected.id} />
                    </Grid>
                    <Grid item md={4}>
                        <Description name="row:" value={selected.row} />
                    </Grid>
                    <Grid item md={4}>
                        <Description name="number:" value={selected.number} />
                    </Grid>
                </Grid>
                <Divider/>
                <Label
                    size='medium'
                    color='dark'
                    align='left'
                    weight='700'
                    padding='5px 0'
                >
                    convidado
                </Label>
                </DialogContent>
                {
                    props.person.id ?
                    (<>
                        <DialogContent>
                            <Grid
                                container
                                spacing={2}
                                direction="row"
                                justify="flex-start"
                                alignItems="flex-start"
                            >
                                <Grid item xs={12} sm={6} md={8}>
                                    <Description name="id:" value={props.person.id} />
                                    <Description name="nome:" value={props.person.name} />
                                    <Description name="email:" value={props.person.email} />
                                    <Description name="cpf:" value={props.person.cpf} />
                                    <Description name="phone:" value={props.person.phone} />
                                    <Description
                                        name="status:"
                                        value={status[props.person.status_id] ?
                                            statusEnum[status[props.person.status_id].name]
                                            :toString(props.person.status_id)}
                                    />
                                    <Description name="vip:" value={props.person.vip ? 'SIM':'NÃO'} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <img
                                        style={{height: '150px', width: '150px',}}
                                        src={`${config.QRCODE_HOST}/?size=200x200&data=${config.FRONT_HOST}/invited/${props.person.id}`}
                                        alt="qrcode"
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                cancelar
                            </Button>
                            {currentButton}
                        </DialogActions>
                    </>): <CreatePerson
                            handleClose={handleClose}
                            selected={selected} 
                            categoryNames={props.categoryNames}
                            categoryValues={props.categoryValues}
                            gradeNames={props.gradeNames}
                            gradeValues={props.gradeValues}
                            eventData={props.data}
                        />
                }
            </ContainerBox>
        </Dialog>
    )

    return (
        <ContainerBox>
            {modal}
            <Content>
                <Label
                    size='medium'
                    color='dark'
                    align='left'
                    weight='700'
                >
                    {props.data.name}
                </Label>
                <Container className="container" maxWidth="md">
                    <Row>
                        <Container className="container" maxWidth="md">
                            <div style={{margin: '20px'}}>
                                <SeatPicker
                                    addSeatCallback={addSeatCallback}
                                    removeSeatCallback={removeSeatCallback}
                                    rows={rows}
                                    maxReservableSeats={props.data.lines * props.data.columns}
                                    alpha={false}
                                    visible
                                    selectedByDefault
                                    tooltipProps={{multiline: true}}
                                />
                            </div>
                        </Container>
                    </Row>
                </Container>
            </Content>
        </ContainerBox>
    )
}

export default Map;
